(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["best-sellers-rstore"] && !Shopify.designMode) return;
  try {
    
class BestSellersDots extends HTMLElement {
  connectedCallback() {
    this.sliderComponent = this.querySelector('slider-component');
    this.dotsContainer = this.querySelector('[data-dots]');
    if (!this.sliderComponent || !this.dotsContainer) return;

    requestAnimationFrame(() => this.build());

    this.sliderComponent.addEventListener('slideChanged', (event) => {
      this.setActive(event.detail.currentPage);
    });

    window.addEventListener('resize', () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.build(), 200);
    });
  }

  build() {
    const total = this.sliderComponent.totalPages || 1;
    this.dotsContainer.innerHTML = '';

    if (total <= 1) {
      this.dotsContainer.style.display = 'none';
      return;
    }
    this.dotsContainer.style.display = '';

    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'bs__dot';
      dot.setAttribute('aria-label', 'Página ' + (i + 1));
      dot.addEventListener('click', () => this.goToPage(i));
      this.dotsContainer.appendChild(dot);
    }
    this.setActive(this.sliderComponent.currentPage || 1);
  }

  goToPage(index) {
    const slider = this.sliderComponent.slider;
    const offset = this.sliderComponent.sliderItemOffset || 0;
    const perPage = this.sliderComponent.slidesPerPage || 1;
    slider.scrollTo({ left: index * offset * perPage, behavior: 'smooth' });
  }

  setActive(page) {
    const dots = this.dotsContainer.querySelectorAll('.bs__dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === page - 1);
    });
  }
}

if (!customElements.get('best-sellers-dots')) {
  customElements.define('best-sellers-dots', BestSellersDots);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-video-rstore"] && !Shopify.designMode) return;
  try {
    
class HeroVideoBg extends HTMLElement {
  connectedCallback() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
    } else {
      this.init();
    }
  }

  init() {
    this.desktopVid = this.querySelector('.hero-video__vid--desktop');
    this.mobileVid = this.querySelector('.hero-video__vid--mobile');
    const videos = [this.desktopVid, this.mobileVid].filter(Boolean);
    if (!videos.length) return;

    videos.forEach((video) => {
      video.muted = true;
      const sources = video.innerHTML.trim();
      if (sources) video.dataset.sources = sources;
    });

    this.desktopQuery = window.matchMedia('(min-width: 750px)');
    this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.apply = this.apply.bind(this);

    this.apply();
    this.desktopQuery.addEventListener('change', this.apply);
    this.motionQuery.addEventListener('change', this.apply);
  }

  disconnectedCallback() {
    if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.apply);
    if (this.motionQuery) this.motionQuery.removeEventListener('change', this.apply);
  }

  apply() {
    const isDesktop = this.desktopQuery.matches;
    this.unload(isDesktop ? this.mobileVid : this.desktopVid);
    this.activate(isDesktop ? this.desktopVid : this.mobileVid);
  }

  activate(video) {
    if (!video) return;
    video.muted = true;
    if (!video.querySelector('source') && video.dataset.sources) {
      video.innerHTML = video.dataset.sources;
      try { video.load(); } catch (e) {}
    }
    if (this.motionQuery.matches) {
      video.removeAttribute('autoplay');
      video.pause();
      return;
    }
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  }

  unload(video) {
    if (!video) return;
    video.pause();
    video.removeAttribute('autoplay');
    if (video.querySelector('source')) {
      video.innerHTML = '';
      video.removeAttribute('src');
      try { video.load(); } catch (e) {}
    }
  }
}

if (!customElements.get('hero-video-bg')) {
  customElements.define('hero-video-bg', HeroVideoBg);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nebula-header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = this.closest('.shopify-section');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;

      this.onScrollHandler = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
      this.setupAnnouncementSync();
    }

    setupAnnouncementSync() {
      var announcement = document.querySelector('.nebula-announcement-section');
      if (!announcement) return;
      var update = function() {
        var transform = announcement.style.transform || '';
        var isHidden = transform.indexOf('-100%') !== -1 || announcement.style.display === 'none';
        var offset = isHidden ? 0 : announcement.offsetHeight;
        document.documentElement.style.setProperty('--announcement-offset', offset + 'px');
      };
      update();
      var observer = new MutationObserver(update);
      observer.observe(announcement, { attributes: true, attributeFilter: ['style'] });
      window.addEventListener('resize', update);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const hasTransparentHero = document.body.classList.contains('has-transparent-hero');
      const threshold = hasTransparentHero ? 20 : this.headerBounds.bottom;

      if (scrollTop > threshold) {
        this.header.classList.add('scrolled-past-header');
        this.classList.add('scrolled-past-header');
      } else if (scrollTop <= 5) {
        this.header.classList.remove('scrolled-past-header');
        this.classList.remove('scrolled-past-header');
      }

      this.currentScrollTop = scrollTop;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["options-compare-rstore"] && !Shopify.designMode) return;
  try {
    
class OptionsCompare extends HTMLElement {
  connectedCallback() {
    this.cards = Array.from(this.querySelectorAll('.oc__card'));
    this.videos = this.cards.map((card) => card.querySelector('[data-oc-video]'));
    if (!this.cards.length) return;

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.visible = false;
    this.ticking = false;
    this.prefetched = new Set();
    this.playState = [];

    let svSupported = true;
    try {
      svSupported = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: view()'));
    } catch (e) {}
    this.jsAnim = !svSupported && !this.reduceMotion && this.classList.contains('oc--scale');
    if (this.jsAnim) this.classList.add('oc--js-anim');

    this.onScroll = () => this.requestUpdate();
    this.onResize = () => this.requestUpdate();

    this.observer = new IntersectionObserver(
      (entries) => {
        this.visible = entries[0].isIntersecting;
        if (this.visible) {
          this.update();
        } else {
          this.pauseAll();
        }
      },
      { threshold: 0 }
    );
    this.observer.observe(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener('resize', this.onResize);
    this.pauseAll();
  }

  requestUpdate() {
    if (!this.visible || this.ticking) return;
    this.ticking = true;
    window.requestAnimationFrame(() => {
      this.ticking = false;
      this.update();
    });
  }

  update() {
    const styles = getComputedStyle(this);
    const step = parseFloat(styles.getPropertyValue('--oc-stack-step')) || 0;
    let trigger = parseFloat(styles.getPropertyValue('--oc-video-trigger'));
    if (isNaN(trigger)) trigger = 0.7;
    const vh = window.innerHeight || document.documentElement.clientHeight;
    const startRef = vh * trigger;

    let lastEntered = -1;
    this.cards.forEach((card, index) => {
      const rect = card.getBoundingClientRect();
      const inView = rect.bottom > 0 && rect.top < vh;
      const entered = rect.top <= startRef + index * step;
      const next = this.cards[index + 1];
      const covered = next ? next.getBoundingClientRect().top - rect.top <= step + 2 : false;

      this.setPlaying(index, entered && inView && !covered);
      if (this.jsAnim) this.setAnim(index, inView, covered);
      if (entered && inView) lastEntered = index;
    });

    if (lastEntered >= 0) this.schedulePrefetch(lastEntered);
  }

  setPlaying(index, shouldPlay) {
    if (this.playState[index] === shouldPlay) return;
    this.playState[index] = shouldPlay;
    const video = this.videos[index];
    if (!video) return;
    if (shouldPlay && !this.reduceMotion) {
      video.muted = true;
      const playing = video.play();
      if (playing && playing.catch) playing.catch(() => {});
    } else {
      this.resetVideo(video);
    }
  }

  setAnim(index, inView, covered) {
    const inner = this.cards[index].querySelector('.oc__card-inner');
    if (!inner) return;
    if (inView) inner.classList.add('is-in');
    inner.classList.toggle('is-covered', covered);
  }

  schedulePrefetch(index) {
    if (this.reduceMotion) return;
    const next = index + 1;
    if (!this.videos[next] || this.prefetched.has(next)) return;

    const current = this.videos[index];
    if (!current || current.readyState >= 2) {
      this.prefetch(next);
      return;
    }

    const onReady = () => {
      current.removeEventListener('loadeddata', onReady);
      this.prefetch(next);
    };
    current.addEventListener('loadeddata', onReady, { once: true });
  }

  prefetch(index) {
    if (this.reduceMotion) return;
    const video = this.videos[index];
    if (!video || this.prefetched.has(index)) return;
    this.prefetched.add(index);
    video.preload = 'auto';
    try {
      video.load();
    } catch (e) {}
  }

  pauseAll() {
    if (this.videos) this.videos.forEach((video) => this.resetVideo(video));
    this.playState = [];
  }

  resetVideo(video) {
    if (!video) return;
    video.pause();
    try {
      video.currentTime = 0;
    } catch (e) {}
  }
}

if (!customElements.get('options-compare')) {
  customElements.define('options-compare', OptionsCompare);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["products-grid-rstore"] && !Shopify.designMode) return;
  try {
    
class PgridCarousel extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-track]');
    this.dots = this.querySelector('[data-dots]');
    if (!this.track) return;
    this.slides = Array.from(this.track.children);

    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    this.arrows = [this.prevBtn, this.nextBtn].filter(Boolean);
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.goTo(this.currentIndex() - 1));
    }
    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.goTo(this.currentIndex() + 1));
    }

    this.buildDots();
    this.refreshArrows();

    this.track.addEventListener(
      'scroll',
      () => {
        if (this._raf) return;
        this._raf = window.requestAnimationFrame(() => {
          this._raf = null;
          this.setActive(this.currentIndex());
          this.updateArrowState();
        });
      },
      { passive: true }
    );

    window.addEventListener('resize', () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => {
        this.buildDots();
        this.refreshArrows();
        this.maybeStartAutoplay();
      }, 200);
    });

    this.setupAutoplay();
  }

  disconnectedCallback() {
    this.stopAutoplay();
    if (this.desktopMql && this._onMediaChange) {
      this.desktopMql.removeEventListener('change', this._onMediaChange);
    }
  }

  setupAutoplay() {
    this.autoplayEnabled = this.hasAttribute('data-autoplay');
    if (!this.autoplayEnabled) return;

    this.autoplayInterval = parseInt(this.getAttribute('data-autoplay-interval'), 10) || 5000;
    this.desktopMql = window.matchMedia('(min-width: 750px)');
    this.reducedMotionMql = window.matchMedia('(prefers-reduced-motion: reduce)');

    this._onMediaChange = () => this.maybeStartAutoplay();
    this.desktopMql.addEventListener('change', this._onMediaChange);

    ['mouseenter', 'focusin', 'pointerdown', 'touchstart'].forEach((evt) => {
      this.addEventListener(evt, () => this.stopAutoplay(), { passive: true });
    });
    ['mouseleave', 'focusout'].forEach((evt) => {
      this.addEventListener(evt, () => this.maybeStartAutoplay(), { passive: true });
    });

    this.maybeStartAutoplay();
  }

  maybeStartAutoplay() {
    this.stopAutoplay();
    if (!this.autoplayEnabled) return;
    if (!this.desktopMql.matches) return;
    if (this.reducedMotionMql.matches) return;
    if (!this.isScrollable() || this.slides.length <= 1) return;

    this._autoplayTimer = window.setInterval(() => {
      const next = (this.currentIndex() + 1) % this.slides.length;
      this.goTo(next);
    }, this.autoplayInterval);
  }

  stopAutoplay() {
    if (this._autoplayTimer) {
      window.clearInterval(this._autoplayTimer);
      this._autoplayTimer = null;
    }
  }

  isScrollable() {
    return this.track.scrollWidth - this.track.clientWidth > 4;
  }

  buildDots() {
    if (!this.dots) return;
    this.dots.innerHTML = '';

    if (!this.isScrollable() || this.slides.length <= 1) {
      this.dots.style.display = 'none';
      return;
    }
    this.dots.style.display = '';

    this.slides.forEach((slide, i) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'pgrid__dot';
      dot.setAttribute('aria-label', 'Producto ' + (i + 1));
      dot.addEventListener('click', () => this.goTo(i));
      this.dots.appendChild(dot);
    });

    this.setActive(this.currentIndex());
  }

  goTo(index) {
    const slide = this.slides[index];
    if (!slide) return;
    this.track.scrollTo({ left: slide.offsetLeft - this.track.offsetLeft, behavior: 'smooth' });
  }

  currentIndex() {
    const scrollLeft = this.track.scrollLeft;
    let index = 0;
    let min = Infinity;
    this.slides.forEach((slide, i) => {
      const distance = Math.abs(slide.offsetLeft - this.track.offsetLeft - scrollLeft);
      if (distance < min) {
        min = distance;
        index = i;
      }
    });
    return index;
  }

  setActive(index) {
    if (!this.dots) return;
    const dots = this.dots.querySelectorAll('.pgrid__dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === index);
    });
  }

  refreshArrows() {
    if (!this.arrows || !this.arrows.length) return;
    const show = this.isScrollable() && this.slides.length > 1;
    this.arrows.forEach((btn) => {
      btn.style.display = show ? 'flex' : 'none';
    });
    this.updateArrowState();
  }

  updateArrowState() {
    if (!this.arrows || !this.arrows.length) return;
    const t = this.track;
    if (this.prevBtn) this.prevBtn.disabled = t.scrollLeft <= 2;
    if (this.nextBtn) this.nextBtn.disabled = t.scrollLeft + t.clientWidth >= t.scrollWidth - 2;
  }
}

if (!customElements.get('pgrid-carousel')) {
  customElements.define('pgrid-carousel', PgridCarousel);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-light-rstore"] && !Shopify.designMode) return;
  try {
    
class TltMarquee extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('.tlt__track');
    if (!this.track) return;

    this.offset = 0;
    this.period = 0;
    this.lastTime = 0;
    this.isDown = false;
    this.moved = false;
    this.pointerId = null;
    this.hovering = false;
    this.visible = true;

    this.direction = this.dataset.direction === 'right' ? 1 : -1;
    this.autoplay = this.hasAttribute('data-autoplay');
    this.pauseOnHover = this.hasAttribute('data-pause-hover');
    this.dragEnabled = this.hasAttribute('data-drag');

    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.desktopQuery = window.matchMedia('(min-width: 750px)');

    this.onFrame = this.onFrame.bind(this);
    this.measure = this.measure.bind(this);
    this.onVisibility = this.onVisibility.bind(this);

    this.measure();

    if (this.pauseOnHover) {
      this.addEventListener('mouseenter', () => {
        this.hovering = true;
      });
      this.addEventListener('mouseleave', () => {
        this.hovering = false;
      });
    }

    if (this.dragEnabled) {
      this.addEventListener('pointerdown', this.onPointerDown.bind(this));
      this.addEventListener('pointermove', this.onPointerMove.bind(this));
      this.addEventListener('pointerup', this.onPointerUp.bind(this));
      this.addEventListener('pointercancel', this.onPointerUp.bind(this));
      this.addEventListener('click', this.onClick.bind(this), true);
      this.addEventListener('dragstart', (event) => event.preventDefault());
    }

    if ('ResizeObserver' in window) {
      this.resizeObserver = new ResizeObserver(this.measure);
      this.resizeObserver.observe(this);
    } else {
      window.addEventListener('resize', this.measure);
    }

    if ('IntersectionObserver' in window) {
      this.intersectionObserver = new IntersectionObserver((entries) => {
        this.visible = entries[0].isIntersecting;
      });
      this.intersectionObserver.observe(this);
    }

    document.addEventListener('visibilitychange', this.onVisibility);

    this.querySelectorAll('img').forEach((img) => {
      if (!img.complete) img.addEventListener('load', this.measure, { once: true });
    });

    this.raf = requestAnimationFrame(this.onFrame);
  }

  measure() {
    const group = this.querySelector('.tlt__group');
    if (!group) return;

    const styles = window.getComputedStyle(this.track);
    const gap = parseFloat(styles.columnGap) || 0;
    const groupWidth = group.getBoundingClientRect().width;
    if (groupWidth <= 0) return;

    this.period = groupWidth + gap;

    const needed = this.clientWidth + this.period * 2;
    let guard = 0;
    while (this.track.getBoundingClientRect().width < needed && guard < 8) {
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.querySelectorAll('[data-shopify-editor-block]').forEach((node) => {
        node.removeAttribute('data-shopify-editor-block');
      });
      this.track.appendChild(clone);
      guard += 1;
    }

    this.wrap();
  }

  wrap() {
    if (this.period <= 0) return;
    this.offset = this.offset % this.period;
    if (this.offset > 0) this.offset -= this.period;
  }

  get speed() {
    const value = this.desktopQuery.matches ? this.dataset.speedDesktop : this.dataset.speedMobile;
    return parseFloat(value) || 0;
  }

  get paused() {
    return !this.autoplay || this.reduceMotion.matches || this.hovering || this.isDown || !this.visible;
  }

  onFrame(time) {
    const delta = this.lastTime ? Math.min(time - this.lastTime, 100) : 0;
    this.lastTime = time;

    if (!this.paused && this.period > 0) {
      this.offset += (this.direction * this.speed * delta) / 1000;
      this.wrap();
      this.render();
    }

    this.raf = requestAnimationFrame(this.onFrame);
  }

  render() {
    this.track.style.transform = `translate3d(${this.offset}px, 0, 0)`;
  }

  onPointerDown(event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    this.isDown = true;
    this.moved = false;
    this.startX = event.clientX;
    this.startOffset = this.offset;
    this.pointerId = event.pointerId;
    this.classList.add('is-dragging');
  }

  onPointerMove(event) {
    if (!this.isDown) return;
    const dx = event.clientX - this.startX;
    if (Math.abs(dx) > 4) {
      this.moved = true;
      if (this.pointerId !== null && !this.hasPointerCapture(this.pointerId)) {
        this.setPointerCapture(this.pointerId);
      }
    }
    this.offset = this.startOffset + dx;
    this.wrap();
    this.render();
  }

  onPointerUp() {
    if (!this.isDown) return;
    this.isDown = false;
    this.classList.remove('is-dragging');
    if (this.pointerId !== null && this.hasPointerCapture(this.pointerId)) {
      this.releasePointerCapture(this.pointerId);
    }
    this.pointerId = null;
  }

  onClick(event) {
    if (this.moved) {
      event.preventDefault();
      event.stopPropagation();
      this.moved = false;
    }
  }

  onVisibility() {
    this.lastTime = 0;
  }

  disconnectedCallback() {
    if (this.raf) cancelAnimationFrame(this.raf);
    if (this.resizeObserver) this.resizeObserver.disconnect();
    if (this.intersectionObserver) this.intersectionObserver.disconnect();
    document.removeEventListener('visibilitychange', this.onVisibility);
    window.removeEventListener('resize', this.measure);
  }
}

if (!customElements.get('tlt-marquee')) {
  customElements.define('tlt-marquee', TltMarquee);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials-rstore"] && !Shopify.designMode) return;
  try {
    
class TestimonialsDots extends HTMLElement {
  connectedCallback() {
    this.sliderComponent = this.querySelector('slider-component');
    this.dotsContainer = this.querySelector('[data-dots]');
    if (!this.sliderComponent || !this.dotsContainer) return;

    requestAnimationFrame(() => this.build());

    this.sliderComponent.addEventListener('slideChanged', (event) => {
      this.setActive(event.detail.currentPage);
    });

    window.addEventListener('resize', () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.build(), 200);
    });
  }

  build() {
    const total = this.sliderComponent.totalPages || 1;
    this.dotsContainer.innerHTML = '';

    if (total <= 1) {
      this.dotsContainer.style.display = 'none';
      return;
    }
    this.dotsContainer.style.display = '';

    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tst__dot';
      dot.setAttribute('aria-label', 'Página ' + (i + 1));
      dot.addEventListener('click', () => this.goToPage(i));
      this.dotsContainer.appendChild(dot);
    }
    this.setActive(this.sliderComponent.currentPage || 1);
  }

  goToPage(index) {
    const slider = this.sliderComponent.slider;
    const offset = this.sliderComponent.sliderItemOffset || 0;
    const perPage = this.sliderComponent.slidesPerPage || 1;
    slider.scrollTo({ left: index * offset * perPage, behavior: 'smooth' });
  }

  setActive(page) {
    const dots = this.dotsContainer.querySelectorAll('.tst__dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === page - 1);
    });
  }
}

if (!customElements.get('testimonials-dots')) {
  customElements.define('testimonials-dots', TestimonialsDots);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiktok-videos-rstore"] && !Shopify.designMode) return;
  try {
    
class TiktokVideos extends HTMLElement {
  connectedCallback() {
    this.previewMode = this.dataset.previewMode || 'viewport';
    this.cards = Array.from(this.querySelectorAll('[data-tiktok-card]'));
    this.activeCard = null;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.cards.forEach((card) => {
      const trigger = card.querySelector('[data-tiktok-trigger]');
      const video = card.querySelector('[data-tiktok-video]');
      if (!video) return;

      if (trigger) {
        trigger.addEventListener('click', () => {
          if (this.activeCard === card) return;
          this.activate(card, video);
        });
      }

      video.addEventListener('ended', () => this.reset(card, video));

      if (this.previewMode === 'hover') {
        card.addEventListener('mouseenter', () => {
          if (this.activeCard !== card) this.preview(card, video);
        });
        card.addEventListener('mouseleave', () => {
          if (this.activeCard !== card) this.stopPreview(card, video);
        });
      }
    });

    if (this.previewMode === 'viewport' && !this.reduceMotion) this.observe();

    this.setupDots();
  }

  observe() {
    this.io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const card = entry.target;
          const video = card.querySelector('[data-tiktok-video]');
          if (!video || this.activeCard === card) return;
          if (entry.isIntersecting) this.preview(card, video);
          else this.stopPreview(card, video);
        });
      },
      { threshold: 0.6 }
    );
    this.cards.forEach((card) => this.io.observe(card));
  }

  preview(card, video) {
    video.muted = true;
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
    card.classList.add('is-previewing');
  }

  stopPreview(card, video) {
    video.pause();
    card.classList.remove('is-previewing');
  }

  activate(card, video) {
    if (this.activeCard && this.activeCard !== card) {
      const prev = this.activeCard;
      this.reset(prev, prev.querySelector('[data-tiktok-video]'));
    }
    this.activeCard = card;
    card.classList.remove('is-previewing');
    card.classList.add('is-playing');
    video.muted = false;
    video.loop = false;
    video.controls = true;
    try {
      video.currentTime = 0;
    } catch (e) {}
    const playing = video.play();
    if (playing && playing.catch) playing.catch(() => {});
  }

  reset(card, video) {
    if (!video) return;
    video.pause();
    video.controls = false;
    video.muted = true;
    try {
      video.currentTime = 0;
    } catch (e) {}
    card.classList.remove('is-playing');
    if (this.activeCard === card) this.activeCard = null;
  }

  setupDots() {
    this.sliderComponent = this.querySelector('slider-component');
    this.dotsContainer = this.querySelector('[data-dots]');
    if (!this.sliderComponent || !this.dotsContainer) return;

    requestAnimationFrame(() => this.buildDots());

    this.sliderComponent.addEventListener('slideChanged', (event) => {
      this.setActiveDot(event.detail.currentPage);
    });

    window.addEventListener('resize', () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.buildDots(), 200);
    });
  }

  buildDots() {
    const total = this.sliderComponent.totalPages || 1;
    this.dotsContainer.innerHTML = '';

    if (total <= 1) {
      this.dotsContainer.style.display = 'none';
      return;
    }
    this.dotsContainer.style.display = '';

    for (let i = 0; i < total; i++) {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'tiktok__dot';
      dot.setAttribute('aria-label', 'Página ' + (i + 1));
      dot.addEventListener('click', () => this.goToPage(i));
      this.dotsContainer.appendChild(dot);
    }
    this.setActiveDot(this.sliderComponent.currentPage || 1);
  }

  goToPage(index) {
    const slider = this.sliderComponent.slider;
    const offset = this.sliderComponent.sliderItemOffset || 0;
    const perPage = this.sliderComponent.slidesPerPage || 1;
    slider.scrollTo({ left: index * offset * perPage, behavior: 'smooth' });
  }

  setActiveDot(page) {
    const dots = this.dotsContainer.querySelectorAll('.tiktok__dot');
    dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === page - 1);
    });
  }
}

if (!customElements.get('tiktok-videos')) {
  customElements.define('tiktok-videos', TiktokVideos);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reels-rstore"] && !Shopify.designMode) return;
  try {
    
class VideoReels extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('.rs-reels__track');
    this.dotsContainer = this.querySelector('.rs-reels__dots');
    this.cards = Array.from(this.querySelectorAll('.rs-reels__card'));
    this.videos = Array.from(this.querySelectorAll('.rs-reels__video'));
    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.sliderTimer = null;
    this.soundActive = false;
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      const soundBtn = event.target.closest('.rs-reels__sound');
      if (soundBtn) {
        event.preventDefault();
        this.toggleSound(soundBtn.closest('.rs-reels__card'));
      }
    });

    this.setupAutoplayOnVisible();

    if (this.dotsContainer && this.cards.length > 1) {
      this.buildDots();
    }

    this.setupSliderAutoplay();
  }

  disconnectedCallback() {
    this.stopSliderAutoplay();
    if (this.playObserver) this.playObserver.disconnect();
  }

  setupAutoplayOnVisible() {
    if (this.reducedMotion || !this.videos.length) return;
    this.playObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const video = entry.target;
          if (entry.isIntersecting) {
            const playPromise = video.play();
            if (playPromise && typeof playPromise.catch === 'function') {
              playPromise.catch(() => {});
            }
          } else {
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    this.videos.forEach((video) => this.playObserver.observe(video));
  }

  toggleSound(card) {
    if (!card) return;
    const video = card.querySelector('.rs-reels__video');
    const button = card.querySelector('.rs-reels__sound');
    if (!video) return;

    const turnOn = video.muted;

    if (turnOn) {
      this.videos.forEach((other) => {
        if (other !== video) {
          other.muted = true;
          this.setSoundState(other.closest('.rs-reels__card'), false);
        }
      });
    }

    video.muted = !turnOn;
    this.setSoundState(card, turnOn);

    if (turnOn) {
      this.soundActive = true;
      this.stopSliderAutoplay();
      const playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    } else {
      this.soundActive = this.videos.some((v) => !v.muted);
    }

    if (button) button.setAttribute('aria-pressed', turnOn ? 'true' : 'false');
  }

  setSoundState(card, on) {
    if (!card) return;
    const button = card.querySelector('.rs-reels__sound');
    if (!button) return;
    button.setAttribute('aria-pressed', on ? 'true' : 'false');
    button.setAttribute('aria-label', on ? 'Silenciar' : 'Activar sonido');
    const mutedIcon = button.querySelector('.rs-reels__sound-icon--muted');
    const onIcon = button.querySelector('.rs-reels__sound-icon--on');
    if (mutedIcon) mutedIcon.hidden = on;
    if (onIcon) onIcon.hidden = !on;
  }

  setupSliderAutoplay() {
    if (this.dataset.sliderAutoplay !== 'true' || this.reducedMotion) return;
    if (this.cards.length <= 1) return;

    const seconds = parseInt(this.dataset.sliderInterval, 10);
    this.sliderInterval = (isNaN(seconds) ? 5 : seconds) * 1000;

    this.addEventListener('pointerenter', () => this.stopSliderAutoplay());
    this.addEventListener('focusin', () => this.stopSliderAutoplay());
    this.addEventListener('pointerleave', () => {
      if (!this.soundActive) this.startSliderAutoplay();
    });
    this.addEventListener('focusout', () => {
      if (!this.soundActive && !this.contains(document.activeElement)) {
        this.startSliderAutoplay();
      }
    });

    this.startSliderAutoplay();
  }

  startSliderAutoplay() {
    if (!this.sliderInterval || this.sliderTimer) return;
    this.sliderTimer = setInterval(() => this.advanceSlider(), this.sliderInterval);
  }

  stopSliderAutoplay() {
    if (this.sliderTimer) {
      clearInterval(this.sliderTimer);
      this.sliderTimer = null;
    }
  }

  advanceSlider() {
    if (!this.track) return;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    if (this.track.scrollLeft >= maxScroll - 4) {
      this.track.scrollTo({ left: 0, behavior: 'smooth' });
      return;
    }
    const trackLeft = this.track.getBoundingClientRect().left;
    const next = this.cards.find((card) => card.getBoundingClientRect().left - trackLeft > 4);
    if (next) {
      const left = this.track.scrollLeft + (next.getBoundingClientRect().left - trackLeft);
      this.track.scrollTo({ left: left, behavior: 'smooth' });
    }
  }

  buildDots() {
    this.cards.forEach((card, index) => {
      const dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'rs-reels__dot';
      dot.setAttribute('aria-label', 'Ir al video ' + (index + 1));
      if (index === 0) dot.setAttribute('aria-current', 'true');
      dot.addEventListener('click', () => {
        card.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
      this.dotsContainer.appendChild(dot);
    });

    const dots = Array.from(this.dotsContainer.children);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = this.cards.indexOf(entry.target);
            dots.forEach((dot, i) => {
              if (i === index) {
                dot.setAttribute('aria-current', 'true');
              } else {
                dot.removeAttribute('aria-current');
              }
            });
          }
        });
      },
      { root: this.track, threshold: 0.6 }
    );
    this.cards.forEach((card) => observer.observe(card));
  }
}

if (!customElements.get('video-reels')) {
  customElements.define('video-reels', VideoReels);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-grid-rstore"] && !Shopify.designMode) return;
  try {
    
class WatchGrid extends HTMLElement {
  connectedCallback() {
    this.grid = this.querySelector('[data-wg-grid]');
    if (!this.grid) return;

    this.items = Array.from(this.querySelectorAll('[data-wg-item]'));
    this.originalOrder = this.items.slice();
    this.perPage = parseInt(this.dataset.perPage, 10) || 8;
    this.countTemplate = this.dataset.countTemplate || '';
    this.shown = this.perPage;

    this.countEl = this.querySelector('[data-wg-count]');
    this.emptyEl = this.querySelector('[data-wg-empty]');
    this.loadMoreBtn = this.querySelector('[data-wg-loadmore]');
    this.filtersPanel = this.querySelector('[data-wg-filters]');
    this.overlay = this.querySelector('[data-wg-overlay]');
    this.filterToggle = this.querySelector('[data-wg-filter-toggle]');
    this.sortSelect = this.querySelector('[data-wg-sort]');

    this.bindEvents();
    this.update();
  }

  bindEvents() {
    this.querySelectorAll('[data-wg-filter]').forEach((input) => {
      input.addEventListener('change', () => {
        this.shown = this.perPage;
        this.update();
      });
    });

    if (this.sortSelect) {
      this.sortSelect.addEventListener('change', () => this.update());
    }

    window.addEventListener('resize', () => {
      clearTimeout(this._resizeTimer);
      this._resizeTimer = setTimeout(() => this.update(), 200);
    });

    if (this.filterToggle) {
      this.filterToggle.addEventListener('click', () => this.toggleFilters());
    }

    if (this.overlay) {
      this.overlay.addEventListener('click', () => this.toggleFilters(false));
    }

    const closeBtn = this.querySelector('[data-wg-close]');
    if (closeBtn) closeBtn.addEventListener('click', () => this.toggleFilters(false));

    document.addEventListener('click', (event) => {
      if (!this.filtersOpen) return;
      if (window.matchMedia('(max-width: 749px)').matches) return;
      if (this.filtersPanel.contains(event.target)) return;
      if (this.filterToggle && this.filterToggle.contains(event.target)) return;
      this.toggleFilters(false);
    });

    const applyBtn = this.querySelector('[data-wg-apply]');
    if (applyBtn) applyBtn.addEventListener('click', () => this.toggleFilters(false));

    const clearBtn = this.querySelector('[data-wg-clear]');
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        this.querySelectorAll('input[data-wg-filter]').forEach((input) => {
          input.checked = false;
        });
        this.querySelectorAll('select[data-wg-filter]').forEach((select) => {
          select.value = '';
        });
        this.shown = this.perPage;
        this.update();
      });
    }

    if (this.loadMoreBtn) {
      this.loadMoreBtn.addEventListener('click', () => {
        this.shown += this.perPage;
        this.update();
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.filtersOpen) this.toggleFilters(false);
    });
  }

  getActiveFilters() {
    const vendors = [];
    const tags = [];
    const prices = [];

    this.querySelectorAll('select[data-wg-filter]').forEach((select) => {
      if (!select.value) return;
      const kind = select.dataset.wgFilter;
      if (kind === 'vendor') vendors.push(select.value);
      else if (kind === 'tag') tags.push(select.value);
    });

    this.querySelectorAll('input[data-wg-filter]:checked').forEach((input) => {
      if (input.dataset.wgFilter === 'price') {
        const min = input.dataset.min !== '' ? parseFloat(input.dataset.min) * 100 : null;
        const max = input.dataset.max !== '' ? parseFloat(input.dataset.max) * 100 : null;
        prices.push({ min, max });
      }
    });

    return { vendors, tags, prices };
  }

  matches(item, filters) {
    if (filters.vendors.length && !filters.vendors.includes(item.dataset.vendor)) return false;
    if (filters.tags.length) {
      const itemTags = (item.dataset.tags || '').split('|');
      const hasTag = filters.tags.some((tag) => itemTags.includes(tag));
      if (!hasTag) return false;
    }
    if (filters.prices.length) {
      const price = parseFloat(item.dataset.price);
      const inRange = filters.prices.some((range) => {
        if (range.min !== null && price < range.min) return false;
        if (range.max !== null && price > range.max) return false;
        return true;
      });
      if (!inRange) return false;
    }
    return true;
  }

  sortItems(matched) {
    const value = this.sortSelect ? this.sortSelect.value : 'featured';
    const sorted = matched.slice();
    if (value === 'price-asc') {
      sorted.sort((a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price));
    } else if (value === 'price-desc') {
      sorted.sort((a, b) => parseFloat(b.dataset.price) - parseFloat(a.dataset.price));
    } else if (value === 'title-asc') {
      sorted.sort((a, b) => a.dataset.title.localeCompare(b.dataset.title));
    } else if (value === 'newest') {
      sorted.sort((a, b) => parseInt(b.dataset.created, 10) - parseInt(a.dataset.created, 10));
    }
    return sorted;
  }

  update() {
    const filters = this.getActiveFilters();
    const matched = this.originalOrder.filter((item) => this.matches(item, filters));
    const ordered = this.sortItems(matched);

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const limit = isMobile ? ordered.length : this.shown;

    this.originalOrder.forEach((item) => {
      item.hidden = true;
    });

    ordered.forEach((item, index) => {
      this.grid.appendChild(item);
      item.hidden = index >= limit;
    });

    const visible = Math.min(limit, ordered.length);

    if (this.countEl) {
      this.countEl.textContent = this.countTemplate
        .replace('[shown]', visible)
        .replace('[total]', ordered.length);
    }

    if (this.emptyEl) this.emptyEl.hidden = ordered.length !== 0;

    if (this.loadMoreBtn) {
      this.loadMoreBtn.hidden = isMobile || ordered.length <= this.shown;
    }
  }

  toggleFilters(force) {
    if (!this.filtersPanel) return;
    const open = typeof force === 'boolean' ? force : this.filtersPanel.hidden;
    this.filtersOpen = open;
    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (open) {
      this.filtersPanel.hidden = false;
      if (this.overlay) this.overlay.hidden = false;
      requestAnimationFrame(() => {
        this.filtersPanel.classList.add('is-open');
        if (this.overlay) this.overlay.classList.add('is-open');
      });
    } else {
      this.filtersPanel.classList.remove('is-open');
      if (this.overlay) this.overlay.classList.remove('is-open');
      if (isMobile) {
        window.setTimeout(() => {
          this.filtersPanel.hidden = true;
          if (this.overlay) this.overlay.hidden = true;
        }, 300);
      } else {
        this.filtersPanel.hidden = true;
        if (this.overlay) this.overlay.hidden = true;
      }
    }

    if (this.filterToggle) this.filterToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (isMobile) {
      document.body.style.overflow = open ? 'hidden' : '';
    }
  }
}

if (!customElements.get('watch-grid')) {
  customElements.define('watch-grid', WatchGrid);
}

  } catch(e) { console.error(e); }
})();
})();
